<header class="fixed-header" [class.collapsed]="isHeaderCollapsed">
    <div class="header-content px-4 sm:px-6 md:px-8">
        <img
            src="assets/images/landing/pru-portal-logo.png"
            alt="Prudential Logo"
            class="logo h-16 sm:h-20 md:h-24 lg:h-28 object-contain"
            [class.hidden]="isHeaderCollapsed"
        />
        <img
            src="assets/images/landing/pru-portal-logo-scoll.png"
            alt="Prudential Logo"
            class="logo h-8 sm:h-10 md:h-12 object-contain"
            [class.hidden]="!isHeaderCollapsed"
        />

        <div
            class="header-nav"
            [class.items-end]="!isHeaderCollapsed"
            [class.items-center]="isHeaderCollapsed"
        >
            <span class="text-sm sm:text-base md:text-lg">Tentang Prudential</span>
        </div>
    </div>
</header>

<main class="landing-page">
    <section class="banner-section">
        <div
            class="banner-background-image"
            [ngStyle]="{
                'background-image':
                    'url(assets/images/landing/web-banner_PruWorks.jpg)',
            }"
        ></div>
    </section>

    <section class="portal-links-section px-4 sm:px-6 md:px-8 lg:px-12 py-8 sm:py-10 md:py-12">
        <div class="portal-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-7xl mx-auto">
            <div class="portal-item bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
                <img
                    src="assets/images/landing/PRUWorks-Sales-Force.jpg"
                    alt="PRUWorks Sales Force"
                    class="w-full h-48 sm:h-52 md:h-56 object-cover"
                />
                <div class="p-4 sm:p-5 md:p-6">
                    <div class="title-portal text-lg sm:text-xl md:text-2xl font-semibold text-center mb-4 sm:mb-6">PRUWorks Sales Force</div>
                    <div class="sub-title-portal text-sm sm:text-base font-medium mb-3 sm:mb-4">
                        Aplikasi Khusus untuk Tenaga Pemasar
                    </div>
                    <p class="text-sm sm:text-base leading-relaxed mb-4 min-h-[80px] sm:min-h-[100px]">
                        Hitung premi secara cepat dan akurat, serta lakukan proses
                        pengajuan polis asuransi secara cepat, mudah dan menyeluruh
                        langsung dari tangan Anda dimanapun kapanpun dengan PRUWorks
                        Sales Force
                    </p>
                    <a [href]="salesforcePortalUrl" class="portal-action-link text-sm sm:text-base inline-flex items-center min-h-[44px]"
                        >Klik di sini</a
                    >
                </div>
            </div>
            <div class="portal-item bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
                <img
                    src="assets/images/landing/PRUWorks-Employer.jpg"
                    alt="PRUWorks Employer"
                    class="w-full h-48 sm:h-52 md:h-56 object-cover"
                />
                <div class="p-4 sm:p-5 md:p-6">
                    <div class="title-portal text-lg sm:text-xl md:text-2xl font-semibold text-center mb-4 sm:mb-6">PRUWorks Employer</div>
                    <div class="sub-title-portal text-sm sm:text-base font-medium mb-3 sm:mb-4">
                        Portal Khusus untuk Perusahaan Pemberi Pekerjaan
                    </div>
                    <p class="text-sm sm:text-base leading-relaxed mb-4 min-h-[80px] sm:min-h-[100px]">
                        Akses informasi manfaat dan klaim karyawan Anda. Berikan
                        pelayanan administrasi asuransi secara cepat, mudah dan
                        menyeluruh langsung dari tangan Anda dimanapun kapanpun
                        dengan PRUWorks Employer
                    </p>
                    <a [href]="employerPortalUrl" class="portal-action-link text-sm sm:text-base inline-flex items-center min-h-[44px]"
                        >Klik di sini</a
                    >
                </div>
            </div>
            <div class="portal-item bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
                <img
                    src="assets/images/landing/PRUWorks-Employee.jpg"
                    alt="PRUWorks Employee"
                    class="w-full h-48 sm:h-52 md:h-56 object-cover"
                />
                <div class="p-4 sm:p-5 md:p-6">
                    <div class="title-portal text-lg sm:text-xl md:text-2xl font-semibold text-center mb-4 sm:mb-6">PRUWorks Employee</div>
                    <div class="sub-title-portal text-sm sm:text-base font-medium mb-3 sm:mb-4">
                        Aplikasi Khusus untuk Karyawan
                    </div>
                    <p class="text-sm sm:text-base leading-relaxed mb-4 min-h-[80px] sm:min-h-[100px]">
                        Akses informasi manfaat dan klaim secara cepat, mudah dan
                        menyeluruh langsung dari tangan Anda dimanapun kapanpun
                        dengan PRUWorks Employee.
                    </p>
                    <a [href]="employeePortalUrl" class="portal-action-link text-sm sm:text-base inline-flex items-center min-h-[44px]"
                        >Klik di sini</a
                    >
                </div>
            </div>

            <!-- PRUWorks 2.0 portals -->
            <div class="portal-item bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow" *ngIf="showSalesforce2">
                <img
                    src="assets/images/landing/PRUWorks-Sales-Force.2.jpg"
                    alt="PRUWorks Sales Force"
                    class="w-full h-48 sm:h-52 md:h-56 object-cover"
                />
                <div class="p-4 sm:p-5 md:p-6">
                    <div class="title-portal text-lg sm:text-xl md:text-2xl font-semibold text-center mb-4 sm:mb-6">PRUWorks Sales Force 2.0</div>
                    <div class="sub-title-portal text-sm sm:text-base font-medium mb-3 sm:mb-4">
                        Aplikasi Khusus untuk Tenaga Pemasar
                    </div>
                    <p class="text-sm sm:text-base leading-relaxed mb-4 min-h-[80px] sm:min-h-[100px]">
                        Hitung premi secara cepat dan akurat, serta lakukan proses
                        pengajuan polis asuransi secara cepat, mudah dan menyeluruh
                        langsung dari tangan Anda dimanapun kapanpun dengan PRUWorks
                        Sales Force
                    </p>
                    <a [href]="salesforceUrl" class="portal-action-link text-sm sm:text-base inline-flex items-center min-h-[44px]"
                        >Klik di sini</a
                    >
                </div>
            </div>
            <div class="portal-item bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow" *ngIf="showEmployer2">
                <img
                    src="assets/images/landing/PRUWorks-Employer.2.jpg"
                    alt="PRUWorks Employer"
                    class="w-full h-48 sm:h-52 md:h-56 object-cover"
                />
                <div class="p-4 sm:p-5 md:p-6">
                    <div class="title-portal text-lg sm:text-xl md:text-2xl font-semibold text-center mb-4 sm:mb-6">PRUWorks Employer 2.0</div>
                    <div class="sub-title-portal text-sm sm:text-base font-medium mb-3 sm:mb-4">
                        Portal Khusus untuk Perusahaan Pemberi Pekerjaan
                    </div>
                    <p class="text-sm sm:text-base leading-relaxed mb-4 min-h-[80px] sm:min-h-[100px]">
                        Akses informasi manfaat dan klaim karyawan Anda. Berikan
                        pelayanan administrasi asuransi secara cepat, mudah dan
                        menyeluruh langsung dari tangan Anda dimanapun kapanpun
                        dengan PRUWorks Employer
                    </p>
                    <a
                        routerLink="/employer/account/login"
                        class="portal-action-link text-sm sm:text-base inline-flex items-center min-h-[44px]"
                        >Klik di sini</a
                    >
                </div>
            </div>
            <div class="portal-item bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow" *ngIf="showEmployee2">
                <img
                    src="assets/images/landing/PRUWorks-Employee.2.jpg"
                    alt="PRUWorks Employee"
                    class="w-full h-48 sm:h-52 md:h-56 object-cover"
                />
                <div class="p-4 sm:p-5 md:p-6">
                    <div class="title-portal text-lg sm:text-xl md:text-2xl font-semibold text-center mb-4 sm:mb-6">PRUWorks Employee 2.0</div>
                    <div class="sub-title-portal text-sm sm:text-base font-medium mb-3 sm:mb-4">
                        Aplikasi Khusus untuk Karyawan
                    </div>
                    <p class="text-sm sm:text-base leading-relaxed mb-4 min-h-[80px] sm:min-h-[100px]">
                        Akses informasi manfaat dan klaim secara cepat, mudah dan
                        menyeluruh langsung dari tangan Anda dimanapun kapanpun
                        dengan PRUWorks Employee.
                    </p>
                    <a
                        routerLink="/employee/account/login"
                        class="portal-action-link text-sm sm:text-base inline-flex items-center min-h-[44px]"
                        >Klik di sini</a
                    >
                </div>
            </div>
        </div>
    </section>
</main>

<footer class="landing-footer px-4 sm:px-6 md:px-8 py-6 sm:py-8">
    <div class="pt-2 text-center s-media">
        <ul class="nav flex flex-wrap justify-center gap-4 sm:gap-6 md:gap-8">
            <li class="nav-item">
                <a
                    class="nav-link flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full"
                    target="_blank"
                    href="https://www.facebook.com/prudential.indonesia/"
                >
                    <fa-icon [icon]="faFacebookF" class="text-base sm:text-lg"></fa-icon>
                </a>
            </li>
            <li class="nav-item">
                <a
                    class="nav-link flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full"
                    target="_blank"
                    href="https://www.linkedin.com/company/prudential-indonesia-pt-prudential-life-assurance-?trk=tabs_biz_home"
                >
                    <fa-icon [icon]="faLinkedinIn" class="text-base sm:text-lg"></fa-icon>
                </a>
            </li>
            <li class="nav-item">
                <a
                    class="nav-link flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full"
                    target="_blank"
                    href="https://www.youtube.com/user/PrudentialIndonesia"
                >
                    <fa-icon [icon]="faYoutube" class="text-base sm:text-lg"></fa-icon>
                </a>
            </li>
            <li class="nav-item">
                <a
                    class="nav-link flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full"
                    target="_blank"
                    href="https://www.instagram.com/id_prudential/"
                >
                    <fa-icon [icon]="faInstagram" class="text-base sm:text-lg"></fa-icon>
                </a>
            </li>
        </ul>
    </div>

    <div class="py-2 sm:py-4 text-center footer-sub-link">
        <ul class="nav flex flex-wrap justify-center gap-1 text-xs sm:text-sm md:text-base">
            <li class="nav-item">
                <a class="nav-link inline-block py-2 px-2 sm:px-3" href="/id/footer/disclaimer/">Ketentuan</a>
            </li>
            <li class="nav-item">
                <a class="nav-link inline-block py-2 px-2 sm:px-3" href="/id/footer/privacy-policy/"
                    >Kebijakan Privasi</a
                >
            </li>
            <li class="nav-item">
                <a class="nav-link inline-block py-2 px-2 sm:px-3" href="/id/footer/faq/">FAQ</a>
            </li>
            <li class="nav-item">
                <a class="nav-link inline-block py-2 px-2 sm:px-3" target="_blank" href="/id/footer/gdrp/"
                    >Kebijakan GDPR</a
                >
            </li>
        </ul>
    </div>

    <div class="text-center copyright px-2">
        <p class="pb-3 sm:pb-4 text-sm sm:text-base font-bold">
            <strong
                >PT Prudential Life Assurance berizin dan diawasi oleh Otoritas
                Jasa Keuangan</strong
            >
        </p>
        <p class="text-center text-xs sm:text-sm">
            Hak Cipta © 2022 Prudential Indonesia.&nbsp;All rights reserved.
        </p>
    </div>
</footer>
